<res-base-modal [modalTitle]="modalTitle" [modalTitleSecondPart]="modalTitleSecondPart" [modalClass]="modalClass" [modalAutomationId]="autoId"
    [verifyRequiredValidator]="true" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="createManifest()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    [modalHelpIndex]="modalHelpIndex" [ngClass]="{'no-server-section': !hasConnAccessPermissions}">
    <form class="manifest-form">
        <div class="left-panel">
            <div class="section-heading">Fields <span class="required">*</span></div>
            <div class="top-bar">
                <div class="top-bar-content">
                    <div class="total-selected">
                        <span class="selected">Selected: </span> <span class="number"> {{allRowsSelected && !isFiltering
                            ? 'All' :
                            rowsSelected?.length}}</span>
                        <div class="fa fa-hourglass-half" [hidden]="!allRowsSelected || isFiltering"
                            title="Including all fields may take time for the manifest to be generated"
                            [automationId]="autoId + '-hour-glass-icon'">
                        </div>
                    </div>
                    <div class="nav-bar-btn-content">
                        <button type="button" class="secondary-button doc-list-btn" (click)="setDocListFields()"
                            [attr.data-automation-id]="autoId + '-current-doc-list-fields'">Current Doc List
                            Fields</button>
                        <select [(ngModel)]="selectedTemplate" (ngModelChange)="onSelectedTemplateChanged()"
                            class="templates-select" name="selectedTemplate">
                            <option value="Select from Template:" disabled selected>Select from Template:</option>
                            <option checked="true" label="Current Project Settings" value="{{projectHandle}}"
                                data-automation-id="current-project-settings-option"></option>
                            <optgroup label="Organization Templates:" [hidden]="orgTemplates.length === 0">
                                <option *ngFor="let template of orgTemplates" [hidden]="template.orgId === 'DRSystem'"
                                    [ngValue]="template.handle">
                                    {{template.name}}</option>
                            </optgroup>
                            <optgroup label="System Templates:" [hidden]="sysTemplates.length === 0">
                                <option *ngFor="let template of sysTemplates" [hidden]="template.orgId !== 'DRSystem'"
                                    [ngValue]="template.handle">
                                    {{template.name}}</option>
                            </optgroup>
                        </select>
                        <div>
                            <res-custom-checkbox name="hideUnchecked" [automationId]="autoId + '-hide-unchecked'"
                                [(ngModel)]="hideUnchecked" content="Hide Unchecked" (ngModelChange)="onChange()">
                            </res-custom-checkbox>
                        </div>
                    </div>
                </div>
                <res-generic-grid [gridName]="gridName" [automationId]="autoId" [(isBusy)]="isBusy"
                    [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs" [requestInfo]="requestInfo"
                    [onSelectionChanged]="onSelectionChanged" [pagerVisible]="false" [rowSelection]="rowSelection"
                    [gridContext]="gridContext">
                </res-generic-grid>
            </div>
        </div>
        <div class="right-panel">
            <div class="section">
                <div class="section-heading">File Format</div>
                <div class="fields-section">
                    <res-custom-radio-button [automationId]="autoId + '-file-format-csv'" [(ngModel)]="fileExtension"
                        content="CSV" name="fileExtension" value=".csv"></res-custom-radio-button>
                    <res-custom-radio-button [automationId]="autoId + '-file-format-xml'" [(ngModel)]="fileExtension"
                        content="XML" name="fileExtension" value=".xml"></res-custom-radio-button>
                </div>
            </div>

            <div class="section">
                <div class="section-heading">Destination</div>
                <div class="fields-section">
                    <res-custom-radio-button [automationId]="autoId + '-destination-download'" [(ngModel)]="destination"
                        content="Download" name="destination" value="download"></res-custom-radio-button>
                    <res-custom-radio-button *ngIf="hasConnAccessPermissions"
                        [automationId]="autoId + '-destination-save-to-server'" [(ngModel)]="destination"
                        content="Save to Server:" name="destination" value="server"></res-custom-radio-button>
                    <div class="serverOptions" *ngIf="hasConnAccessPermissions">
                        <div class="labels-section">
                            <label for="dataArea" [class.disabled]="destination !== 'server'">
                                Export Data Area: <span *ngIf="destination === 'server'" class="required">*</span>
                            </label>
                            <label for="fileName" [class.disabled]="destination !== 'server'">
                                File Name: <span *ngIf="destination === 'server'" class="required">*</span>
                            </label>
                        </div>
                        <div class="pulldowns">
                            <div>
                                <select name="dataArea" [disabled]="destination !== 'server'"
                                    [(ngModel)]='selectedDataArea' name='selectedDataArea'
                                    data-automation-id="create-manifest-destination-export-data-area-option">
                                    <option *ngFor="let dataArea of dataAreas" [value]="dataArea.handle">
                                        {{dataArea.name}}
                                    </option>
                                </select>
                            </div>
                            <div>
                                <input type="text" [disabled]="destination !== 'server'" name="filename"
                                    [(ngModel)]="filename" [value]="filename"
                                    data-automation-id="create-manifest-destination-file-name-input">
                            </div>
                        </div>
                        <div class="extension">
                            <label for="dataArea"></label>
                            <label for="fileName" [class.invisible]="destination !== 'server'">
                                {{fileExtension}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</res-base-modal>